import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, TransitionGroup as _TransitionGroup, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, Teleport as _Teleport, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-02f666d4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "toasts" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Toast = _resolveComponent("Toast")!

  return (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_TransitionGroup, { name: "slide" }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.toasts, (value, key, index) => {
            return (_openBlock(), _createBlock(_component_Toast, {
              key: key,
              message: value.text,
              type: value.type,
              onFinished: ($event: any) => (_ctx.removeToast(key))
            }, null, 8, ["message", "type", "onFinished"]))
          }), 128))
        ]),
        _: 1
      })
    ])
  ]))
}